import L from "leaflet";

export const createClusterCustomIcon = cluster => {
  const count = cluster.getChildCount();
  let size = "LargeXL";

  if (count < 10) {
    size = "Small";
  } else if (count >= 10 && count < 100) {
    size = "Medium";
  } else if (count >= 100) {
    size = "Large";
  }
  const options = {
    cluster: `markerCluster${size}`
  };

  const clusterIcon = L.divIcon({
    html: `
          <span class="markerClusterLabel">${count}</span>
        `,
    className: `${options.cluster}`
  });

  return clusterIcon;
};
